import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 14.001a1 1 0 0 1 1 1v2.995h3.005a1 1 0 1 1 0 2H20v3.005a1 1 0 1 1-2 0v-3.005h-2.995a1 1 0 0 1 0-2H18v-2.995a1 1 0 0 1 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.116 4.007A1 1 0 0 1 22 5v5h5l.116.007A1 1 0 0 1 28 11v16l-.007.117A1 1 0 0 1 27 28H11l-.116-.007A1 1 0 0 1 10 27v-5H5l-.117-.007A1 1 0 0 1 4 21V5l.007-.116A1 1 0 0 1 5 4h16zM12.001 26h14V12h-14zm-6-6H10v-9l.007-.116A1 1 0 0 1 11 10h9l.001-4h-14z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconDuplicate = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDuplicate);
export default Memo;
